/**
 * Bearer-token auth helpers.
 *
 * We use Bearer tokens as a more reliable alternative to cookies, since some
 * cloud ingress layers strip cookies or break CORS+credentials combinations.
 *
 * Tokens are stored in sessionStorage so they survive page reloads in the same
 * tab but don't persist beyond the session (safer than localStorage).
 */

import axios from 'axios';

const ACCESS_KEY = 'sttn_access_token';
const REFRESH_KEY = 'sttn_refresh_token';

export const setAuthTokens = ({ access_token, refresh_token }) => {
  if (access_token) sessionStorage.setItem(ACCESS_KEY, access_token);
  if (refresh_token) sessionStorage.setItem(REFRESH_KEY, refresh_token);
  if (access_token) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${access_token}`;
  }
};

export const clearAuthTokens = () => {
  sessionStorage.removeItem(ACCESS_KEY);
  sessionStorage.removeItem(REFRESH_KEY);
  delete axios.defaults.headers.common['Authorization'];
};

export const getAccessToken = () => sessionStorage.getItem(ACCESS_KEY);
export const getRefreshToken = () => sessionStorage.getItem(REFRESH_KEY);

// Initialise axios default on app boot if a token is already cached
const cached = getAccessToken();
if (cached) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${cached}`;
}
